import getConfig from 'next/config'

import { ApiVersion } from './type'

export const BASE_URL = (apiVersion: ApiVersion = 'v1') => {
  const { publicRuntimeConfig, IS_STORYBOOK } = getConfig()
  const { API_ENDPOINT } = publicRuntimeConfig

  if (IS_STORYBOOK) return `/${apiVersion}`

  return process.env.NODE_ENV === 'production'
    ? `${API_ENDPOINT}/bank/${apiVersion}`
    : `${API_ENDPOINT}/${apiVersion}`
}

export const BASE_IAM_URL = () => {
  const { publicRuntimeConfig, IS_STORYBOOK } = getConfig()
  const { API_ENDPOINT, IAM_API_ENDPOINT } = publicRuntimeConfig

  if (IS_STORYBOOK) return `/`

  return process.env.NODE_ENV === 'production'
    ? `${API_ENDPOINT}/iam`
    : `${IAM_API_ENDPOINT}`
}

export function BASE_THEMIS_URL(apiVersion: ApiVersion = 'v1') {
  const { publicRuntimeConfig, IS_STORYBOOK } = getConfig()
  const { THEMIS_API_ENDPOINT } = publicRuntimeConfig

  if (IS_STORYBOOK) return `/${apiVersion}`

  return process.env.NODE_ENV === 'production'
    ? `${THEMIS_API_ENDPOINT}/card/${apiVersion}`
    : `${THEMIS_API_ENDPOINT}/${apiVersion}`
}

/**
 * Hydra Admin APIのベースURLを取得する
 * @returns Hydra Admin APIのベースURL
 */
export const BASE_HYDRA_ADMIN_URL = () => {
  const { publicRuntimeConfig } = getConfig()
  const { HYDRA_ADMIN_API_BASE_URL } = publicRuntimeConfig

  return HYDRA_ADMIN_API_BASE_URL
}

//Due to the contract with moneytree, it is necessary to communicate from
// the PRESIDENT CARD client in the UPSIDER api domain.
export const BASE_UPSIDER_IAM_URL = () => {
  const { publicRuntimeConfig } = getConfig()
  const { UPSIDER_API_ENDPOINT } = publicRuntimeConfig

  return process.env.NODE_ENV === 'production'
    ? `${UPSIDER_API_ENDPOINT}/iam`
    : `${UPSIDER_API_ENDPOINT}`
}

// We don't specify apiVersion here because apiVersion is defined in CreditAPI schema, /credit-api/docs/openapi.yaml
export const BASE_CREDIT_API_URL = () => {
  const { publicRuntimeConfig, IS_STORYBOOK } = getConfig()
  const { CREDIT_API_ENDPOINT } = publicRuntimeConfig

  if (IS_STORYBOOK) return `/`

  return CREDIT_API_ENDPOINT
}

// We don't specify apiVersion here because apiVersion is defined in SOLARIS API schema, /src/api/schema/solaris/user-gateway-schema.yml
export const BASE_SOLARIS_URL = () => {
  const { publicRuntimeConfig, IS_STORYBOOK } = getConfig()
  const { SOLARIS_API_ENDPOINT } = publicRuntimeConfig

  if (IS_STORYBOOK) return `/`

  return SOLARIS_API_ENDPOINT
}
